import * as React from "react";
import { KeyedImgFrame } from "src/business/attribute/attrEdits/AttrExternalImages/KeyedImgFrame";

import { ImageDetails } from "./ImageDetails";
import * as styles from "./ImagePreview.module.less";

type PropsImagePreview = {
  frames: KeyedImgFrame[];
  maxWidth?: number | string;
  maxHeight?: number | string;
  startIndex?: number;
  showCounter?: boolean;
};

export const ImagePreview: React.FC<PropsImagePreview> = (props) => {
  const [open, setOpen] = React.useState(false);
  const { frames, maxWidth, maxHeight, startIndex = 0, showCounter } = props;
  const mainFrame = frames[startIndex];
  if (!mainFrame) return null;
  const counter =
    showCounter && frames.length > 1 ? `+${frames.length - 1}` : null;
  const css: React.CSSProperties = { maxWidth, maxHeight };
  const onOpen: React.MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  };
  return (
    <>
      <button
        type="button"
        className={styles.box}
        onClick={onOpen}
        tabIndex={-1}
      >
        <div className={styles.imageBox}>
          <img src={mainFrame.thumbUrl ?? mainFrame.url} alt="" style={css} />
        </div>
        {counter && <div className={styles.counter}>{counter}</div>}
      </button>
      {open && (
        <ImageDetails
          frames={[...frames]}
          close={() => setOpen(false)}
          startIndex={startIndex}
        />
      )}
    </>
  );
};
